module.exports = __webpack_public_path__ + "img/ic_last_page.3c948e20.svg";